<form class="pm" [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
      novalidate #frm="ngForm" (ngSubmit)="onSalvar()">

  <header class="pm-cab">
    <div class="pm-cab__textos">
      <span class="pm-cab__sobre"><i class="fe-tag"></i> Promoções</span>
      <h2>{{promocao.id ? 'Editar promoção' : 'Nova promoção'}}</h2>
    </div>
    <button type="button" class="pm-fechar" (click)="fechar()" aria-label="Fechar"><i class="fe-x"></i></button>
  </header>

  <div class="pm-layout">
    <div class="pm-corpo">

      <!-- 1. Nome -->
      <section class="pm-passo">
        <div class="pm-passo__cab">
          <span class="pm-passo__num">1</span>
          <div>
            <h3>Nome</h3>
            <p>Aparece no carrinho do cliente junto com o desconto.</p>
          </div>
        </div>
        <input type="text" class="form-control pm-input pm-input--grande" autocomplete="off" appAutoFocus [autoFocus]="true"
               id="nome" name="nome" [(ngModel)]="promocao.descricao" #nome="ngModel"
               placeholder="Ex.: Terça em dobro" required/>
        <div class="invalid-feedback">
          <p *ngIf="nome.errors?.required">Dê um nome para a promoção</p>
        </div>
      </section>

      <!-- 2. Regras -->
      <section class="pm-passo">
        <div class="pm-passo__cab">
          <span class="pm-passo__num">2</span>
          <div>
            <h3>O que ganha desconto</h3>
            <p *ngIf="!promocao.regras.length">Escolha um tipo de regra para começar.</p>
            <p *ngIf="promocao.regras.length">{{totalRegrasValidas()}} {{totalRegrasValidas() === 1 ? 'regra' : 'regras'}} nesta promoção.</p>
          </div>
        </div>

        <div class="pm-tipos pm-tipos--inicio" *ngIf="!promocao.regras.length">
          <button type="button" class="pm-tipo" *ngFor="let tipo of tiposDeRegra" (click)="adicionarRegra(tipo.id)">
            <span class="pm-tipo__icone"><i [ngClass]="tipo.icone"></i></span>
            <span class="pm-tipo__textos">
              <strong>{{tipo.descricao}}</strong>
              <small>{{tipo.dica}}</small>
            </span>
            <i class="fe-chevron-right pm-tipo__seta"></i>
          </button>
        </div>

        <ng-container *ngIf="promocao.regras.length">
          <ul class="pm-regras">
            <li class="pm-regra" *ngFor="let regra of promocao.regras"
                [class.pm-regra--removida]="regra.removida" [class.pm-regra--inativa]="!regra.ativa && !regra.removida">
              <span class="pm-regra__icone"><i [ngClass]="iconeDaRegra(regra)"></i></span>

              <div class="pm-regra__textos">
                <strong>{{descrevaRegra(regra)}}</strong>
                <div class="pm-regra__meta">
                  <span *ngIf="regra.removida">Sai ao salvar</span>
                  <ng-container *ngIf="!regra.removida">
                    <span *ngIf="!regra.ativa" class="pm-regra__pausada">Pausada</span>
                    <span *ngIf="regra.maximoAplicacoes">Até {{regra.maximoAplicacoes}}x</span>
                    <span *ngIf="regra.valorMinimoPedido > 0">Pedido mín. R$ {{regra.valorMinimoPedido | number : '1.2-2'}}</span>
                    <span *ngIf="!regra.maximoAplicacoes && !(regra.valorMinimoPedido > 0) && regra.ativa">Sem mínimo</span>
                  </ng-container>
                </div>
              </div>

              <div class="pm-regra__acoes" *ngIf="!regra.removida">
                <label class="pm-switch pm-switch--sm" [title]="regra.ativa ? 'Pausar regra' : 'Ativar regra'">
                  <input type="checkbox" role="switch" [(ngModel)]="regra.ativa" [ngModelOptions]="{standalone: true}"
                         aria-label="Regra ativa">
                  <span class="pm-switch__trilho"></span>
                </label>
                <button type="button" class="pm-icone-btn" (click)="editarRegra(regra)" title="Editar regra" aria-label="Editar regra">
                  <i class="fe-edit-2"></i>
                </button>
                <button type="button" class="pm-icone-btn pm-icone-btn--perigo" (click)="removerRegra(regra)"
                        title="Remover regra" aria-label="Remover regra">
                  <i class="fe-trash-2"></i>
                </button>
              </div>
              <button type="button" class="pm-btn pm-btn--suave pm-btn--sm" *ngIf="regra.removida" (click)="cancelarRemocao($event, regra)">
                <i class="fe-rotate-ccw"></i> Desfazer
              </button>
            </li>
          </ul>

          <button type="button" class="pm-adicionar" (click)="adicionarRegra()">
            <i class="fe-plus"></i> Adicionar outra regra
          </button>
        </ng-container>
      </section>

      <!-- 3. Quando vale -->
      <section class="pm-passo">
        <div class="pm-passo__cab">
          <span class="pm-passo__num">3</span>
          <div>
            <h3>Quando vale</h3>
            <p>Período em que o desconto vale, do primeiro ao último dia.</p>
          </div>
        </div>

        <div class="pm-periodo">
          <div class="pm-periodo__campo">
            <label class="pm-rotulo" for="dataInicio">Começa em</label>
            <kendo-datepicker [(ngModel)]="promocao.dataInicio" id="dataInicio" name="dataInicio" [format]="'dd/MM/yyyy'"
                              class="pm-data" placeholder="dd/mm/aaaa" required
                              [min]="(promocao.dataInicio && (promocao.dataInicio < hoje)) ? promocao.dataInicio : hoje">
              <kendo-datepicker-messages today="Hoje" toggle="Alterar data"></kendo-datepicker-messages>
            </kendo-datepicker>
          </div>
          <span class="pm-periodo__seta"><i class="fe-arrow-right"></i></span>
          <div class="pm-periodo__campo">
            <label class="pm-rotulo" for="dataFim">Termina em</label>
            <kendo-datepicker [(ngModel)]="promocao.dataFim" id="dataFim" name="dataFim" [format]="'dd/MM/yyyy'"
                              class="pm-data" placeholder="dd/mm/aaaa" required
                              [min]="promocao.dataInicio">
              <kendo-datepicker-messages today="Hoje" toggle="Alterar data"></kendo-datepicker-messages>
            </kendo-datepicker>
          </div>
        </div>
        <p class="pm-feedback" *ngIf="frm.submitted && (!promocao.dataInicio || !promocao.dataFim)">Informe o começo e o fim da promoção</p>

        <div class="pm-dias-cab">
          <span class="pm-rotulo">Dias da semana</span>
          <div class="pm-atalhos">
            <button type="button" [class.pm-atalho--on]="atalhoDias() === 'todos'" class="pm-atalho" (click)="marqueDias('todos')">Todos</button>
            <button type="button" [class.pm-atalho--on]="atalhoDias() === 'uteis'" class="pm-atalho" (click)="marqueDias('uteis')">Seg a sex</button>
            <button type="button" [class.pm-atalho--on]="atalhoDias() === 'fds'" class="pm-atalho" (click)="marqueDias('fds')">Fim de semana</button>
          </div>
        </div>
        <div class="pm-dias" role="group" aria-label="Dias da semana">
          <button type="button" class="pm-dia" *ngFor="let ds of disponibilidadesSemana"
                  [class.pm-dia--on]="ds.disponivel" [attr.aria-pressed]="ds.disponivel"
                  (click)="onSelectedChange(ds, !ds.disponivel)">
            <span class="pm-dia__marca"><i class="fe-check"></i></span>
            {{ds.label}}
          </button>
        </div>
      </section>

      <!-- 4. Ajustes -->
      <section class="pm-passo">
        <div class="pm-passo__cab">
          <span class="pm-passo__num">4</span>
          <div>
            <h3>Ajustes</h3>
          </div>
        </div>

        <div class="pm-ajustes">
          <label class="pm-ajuste">
            <span class="pm-ajuste__icone pm-ajuste__icone--verde"><i class="fe-zap"></i></span>
            <span class="pm-ajuste__textos">
              <strong>Promoção ativa</strong>
              <small>Desligada, fica salva mas não dá desconto</small>
            </span>
            <span class="pm-switch">
              <input type="checkbox" role="switch" [(ngModel)]="promocao.ativa" name="ativa" id="ativa">
              <span class="pm-switch__trilho"></span>
            </span>
          </label>
          <label class="pm-ajuste">
            <span class="pm-ajuste__icone pm-ajuste__icone--roxo"><i class="fe-layers"></i></span>
            <span class="pm-ajuste__textos">
              <strong>Cumulativa</strong>
              <small>Soma com outras promoções no mesmo pedido</small>
            </span>
            <span class="pm-switch">
              <input type="checkbox" role="switch" [(ngModel)]="promocao.cumulativa" name="cumulativa" id="cumulativa">
              <span class="pm-switch__trilho"></span>
            </span>
          </label>
        </div>
      </section>

      <div class="pm-erro" role="alert" *ngIf="mensagemErro">
        <i class="fe-alert-triangle"></i>
        <span>{{mensagemErro}}</span>
      </div>
    </div>

    <!-- Prévia -->
    <aside class="pm-lado" aria-label="Resumo da promoção">
      <span class="pm-lado__rotulo">Resumo</span>

      <div class="pm-cupom" [class.pm-cupom--pausado]="!promocao.ativa">
        <div class="pm-cupom__topo">
          <div class="pm-cupom__linha">
            <span class="pm-cupom__selo"><i class="fe-tag"></i> Promoção</span>
            <span class="pm-cupom__status">
              <span class="pm-cupom__ponto"></span>{{promocao.ativa ? 'Ativa' : 'Pausada'}}
            </span>
          </div>

          <div class="pm-cupom__destaque" *ngIf="maiorDesconto() as desconto; else semDesconto">
            <small>até</small>
            <span>{{desconto}}<em>%</em></span>
            <small>off</small>
          </div>
          <ng-template #semDesconto>
            <div class="pm-cupom__destaque pm-cupom__destaque--icone"><i class="fe-gift"></i></div>
          </ng-template>

          <strong class="pm-cupom__nome" [class.pm-cupom__nome--vazio]="!promocao.descricao">
            {{promocao.descricao || 'Nome da promoção'}}
          </strong>
        </div>

        <div class="pm-cupom__corte" aria-hidden="true"></div>

        <div class="pm-cupom__base">
          <ul class="pm-cupom__regras" *ngIf="totalRegrasValidas(); else semRegras">
            <ng-container *ngFor="let regra of promocao.regras">
              <li *ngIf="!regra.removida" [class.pm-cupom__regra--off]="!regra.ativa">
                <i [ngClass]="iconeDaRegra(regra)"></i>
                <span>{{descrevaRegra(regra)}}</span>
              </li>
            </ng-container>
          </ul>
          <ng-template #semRegras>
            <p class="pm-cupom__vazio">As regras aparecem aqui.</p>
          </ng-template>

          <dl class="pm-cupom__dados">
            <div>
              <dt><i class="fe-calendar"></i> Período</dt>
              <dd>{{periodoTexto()}}</dd>
            </div>
            <div>
              <dt><i class="fe-clock"></i> Dias</dt>
              <dd>{{diasTexto()}}</dd>
            </div>
          </dl>

          <span class="pm-cupom__chip" *ngIf="promocao.cumulativa"><i class="fe-layers"></i> Soma com outras promoções</span>
        </div>
      </div>
    </aside>
  </div>

  <footer class="pm-rodape">
    <span class="pm-rodape__nota"><i class="fe-info"></i> O desconto entra sozinho no carrinho.</span>
    <div class="pm-rodape__botoes">
      <button type="button" class="pm-btn pm-btn--fantasma" (click)="fechar()">Cancelar</button>
      <button type="submit" class="pm-btn pm-btn--primario" [disabled]="salvando">
        <span class="pm-spinner" *ngIf="salvando"></span>
        <i class="fe-check" *ngIf="!salvando"></i>
        {{salvando ? 'Salvando…' : 'Salvar promoção'}}
      </button>
    </div>
  </footer>
</form>

<kendo-dialog class="pm-dialogo-regra" *ngIf="abraDialogoRegra" (close)="fecharDialogRegra()" [minWidth]="250" [width]="620"
              [maxHeight]="'92vh'">
  <form class="pm pm--regra" [ngClass]="{'needs-validation': !frmRegra.submitted, 'was-validated': frmRegra.submitted}"
        novalidate #frmRegra="ngForm" (ngSubmit)="salvarRegra(frmRegra)">

    <header class="pm-cab">
      <div class="pm-cab__textos">
        <span class="pm-cab__sobre"><i class="fe-percent"></i> Regra da promoção</span>
        <h2>{{novaRegra ? 'Nova regra' : 'Editar regra'}}</h2>
      </div>
      <button type="button" class="pm-fechar" (click)="fecharDialogRegra()" aria-label="Fechar"><i class="fe-x"></i></button>
    </header>

    <div class="pm-corpo">
      <section class="pm-passo">
        <div class="pm-passo__cab pm-passo__cab--simples">
          <h3>Tipo</h3>
        </div>
        <div class="pm-tipos" role="radiogroup">
          <label class="pm-tipo pm-tipo--radio" *ngFor="let tipo of tiposDeRegra"
                 [class.pm-tipo--on]="regra.tipo === tipo.id" [class.pm-tipo--bloqueado]="regra.id && regra.tipo !== tipo.id">
            <input type="radio" [id]="tipo.id" name="tipo" [(ngModel)]="regra.tipo" [value]="tipo.id"
                   [disabled]="regra.id" required/>
            <span class="pm-tipo__icone"><i [ngClass]="tipo.icone"></i></span>
            <span class="pm-tipo__textos">
              <strong>{{tipo.descricao}}</strong>
              <small>{{tipo.dica}}</small>
            </span>
            <span class="pm-tipo__marca"><i class="fe-check"></i></span>
          </label>
        </div>
        <div class="pm-feedback" *ngIf="frmRegra.submitted && !regra.tipo">Escolha um tipo de regra</div>
      </section>

      <ng-container *ngIf="regra.tipo">
        <section class="pm-passo">
          <div class="pm-passo__cab pm-passo__cab--simples">
            <h3>Configuração</h3>
          </div>

          <div class="pm-grade-2">
            <div class="pm-campo pm-campo--inteiro" *ngIf="regra.tipo === 'percentual' || regra.tipo === 'percentual-no-segundo' || regra.tipo === 'adicionar-produto'">
              <label class="pm-rotulo">Produto</label>
              <kendo-dropdownlist class="pm-kendo" name="produto"
                                  [data]="produtos"
                                  [filterable]="true"
                                  [textField]="'descricao'" [valueField]="'id'"
                                  [(ngModel)]="regra.produto"
                                  (filterChange)="search($event, (regra.tipo === 'adicionar-produto'))"
                                  (focus)="busquePrimeiraVez(regra.tipo === 'adicionar-produto')">
              </kendo-dropdownlist>
            </div>

            <div class="pm-campo pm-campo--inteiro" *ngIf="regra.tipo === 'percentual' || regra.tipo === 'percentual-no-segundo'">
              <label class="pm-rotulo">Adicional <span class="pm-opcional">opcional</span></label>
              <kendo-combobox class="pm-kendo" textField="nome" valueField="id" name="adicional"
                              [(ngModel)]="regra.adicional" [data]="regra.produto ? regra.produto.camposAdicionais : []"
                              placeholder="Qualquer adicional">
              </kendo-combobox>
            </div>

            <ng-container *ngIf="regra.tipo === 'compre-pizza-ganhe-outra'">
              <div class="pm-campo">
                <label class="pm-rotulo">Tamanho que compra</label>
                <kendo-dropdownlist class="pm-kendo" name="tamanhoPizzaComprar"
                                    [data]="tamanhos" [filterable]="false"
                                    [textField]="'descricao'" [valueField]="'id'"
                                    [(ngModel)]="regra.tamanhoPizzaComprar">
                </kendo-dropdownlist>
              </div>
              <div class="pm-campo">
                <label class="pm-rotulo" for="quantidade">Quantas pizzas</label>
                <kendo-numerictextbox id="quantidade" [min]="0" class="pm-kendo" name="quantidade" #quantidade=ngModel
                                      [decimals]="0" [format]="'#'"
                                      [(ngModel)]="regra.quantidade" required>
                </kendo-numerictextbox>
              </div>
              <div class="pm-campo pm-campo--inteiro">
                <label class="pm-rotulo">Tamanho que ganha</label>
                <kendo-dropdownlist class="pm-kendo" name="tamanhoPizzaGanhar"
                                    [data]="tamanhos" [filterable]="false"
                                    [textField]="'descricao'" [valueField]="'id'"
                                    [(ngModel)]="regra.tamanhoPizzaGanhar">
                </kendo-dropdownlist>
              </div>
            </ng-container>

            <div class="pm-campo" *ngIf="regra.tipo !== 'compre-pizza-ganhe-outra'">
              <label class="pm-rotulo" for="percentual">Desconto</label>
              <kendo-numerictextbox [attr.type]="'number'" id="percentual" name="percentual" class="pm-kendo"
                                    [(ngModel)]="regra.percentual" [min]="1" [max]="100"
                                    [format]="obtenhaFormatoPercentual()"
                                    required>
              </kendo-numerictextbox>
              <div class="invalid-feedback">Informe o percentual de desconto</div>
            </div>

            <div class="pm-campo" *ngIf="regra.tipo === 'percentual' || regra.tipo === 'percentual-no-segundo'">
              <label class="pm-rotulo" for="valor">Máximo de aplicações</label>
              <kendo-numerictextbox id="valor" class="pm-kendo" name="maximoAplicacoes" #maximoAplicacoes=ngModel
                                    [decimals]="0" [format]="'#'" placeholder="Sem limite"
                                    [(ngModel)]="regra.maximoAplicacoes">
              </kendo-numerictextbox>
            </div>

            <div class="pm-campo" *ngIf="regra.tipo !== 'compre-pizza-ganhe-outra'">
              <label class="pm-rotulo" for="valorMinimoPedido">Pedido mínimo (R$)</label>
              <kendo-numerictextbox id="valorMinimoPedido" [min]="0" class="pm-kendo" name="valorMinimoPedido"
                                    #valorMinimoPedido=ngModel
                                    [(ngModel)]="regra.valorMinimoPedido" required>
              </kendo-numerictextbox>
            </div>
          </div>
        </section>

        <section class="pm-passo">
          <div class="pm-ajustes">
            <label class="pm-ajuste">
              <span class="pm-ajuste__icone pm-ajuste__icone--verde"><i class="fe-zap"></i></span>
              <span class="pm-ajuste__textos">
                <strong>Regra ativa</strong>
                <small>Desligada, fica salva sem aplicar</small>
              </span>
              <span class="pm-switch">
                <input type="checkbox" role="switch" [(ngModel)]="regra.ativa" name="ativa" id="regraAtiva">
                <span class="pm-switch__trilho"></span>
              </span>
            </label>
            <label class="pm-ajuste" *ngIf="regra.valorMinimoPedido > 0 && (regra.tipo === 'percentual' || regra.tipo === 'adicionar-produto')">
              <span class="pm-ajuste__icone"><i class="fe-shopping-cart"></i></span>
              <span class="pm-ajuste__textos">
                <strong>Produto conta para o mínimo</strong>
                <small>O valor do próprio produto entra na soma do pedido mínimo</small>
              </span>
              <span class="pm-switch">
                <input type="checkbox" role="switch" [(ngModel)]="regra.produtoCompoeMinimo" name="produtoCompoeMinimo"
                       id="produtoCompoeMinimo">
                <span class="pm-switch__trilho"></span>
              </span>
            </label>
          </div>
        </section>

        <section class="pm-previa">
          <span class="pm-previa__icone"><i class="fe-message-circle"></i></span>
          <div>
            <span class="pm-previa__rotulo">Como vai funcionar</span>
            <ng-container *ngIf="regra.tipo === 'percentual-no-segundo'">
              <p *ngIf="!regra.adicional">Se o cliente colocar <b>{{regra.produto ? regra.produto.nome : 'o produto'}}</b> no carrinho,
                ganha <b>{{regra.percentual ? regra.percentual : '0'}}%</b> de desconto no segundo {{regra.produto ? regra.produto.nome : 'produto'}}.
              </p>
              <p *ngIf="regra.adicional">Se o cliente colocar <b>{{regra.produto.nome}}</b> com o adicional
                <b>{{regra.adicional.nome}}</b>, ganha <b>{{regra.percentual ? regra.percentual : '0'}}%</b> de desconto no segundo adicional.
              </p>
            </ng-container>
            <ng-container *ngIf="regra.tipo === 'percentual'">
              <p *ngIf="!regra.adicional">Se o cliente colocar <b>{{regra.produto ? regra.produto.nome : 'o produto'}}</b> no carrinho,
                ganha <b>{{regra.percentual ? regra.percentual : '0'}}%</b> de desconto no valor do produto.
              </p>
              <p *ngIf="regra.adicional">Se o cliente colocar <b>{{regra.produto.nome}}</b> com o adicional
                <b>{{regra.adicional.nome}}</b>, ganha <b>{{regra.percentual ? regra.percentual : '0'}}%</b> de desconto no valor do produto.
              </p>
            </ng-container>
            <p *ngIf="regra.tipo === 'adicionar-produto'">Quando o carrinho chegar a <b>R$ {{(regra.valorMinimoPedido || 0) | number : '1.2-2'}}</b>,
              <b>{{regra.produto ? regra.produto.nome : 'o produto'}}</b> entra no carrinho com
              <b>{{regra.percentual ? regra.percentual : '0'}}%</b> de desconto.
            </p>
            <p *ngIf="regra.tipo === 'percentual-todos'">Qualquer produto colocado no carrinho ganha
              <b>{{regra.percentual ? regra.percentual : '0'}}%</b> de desconto.
            </p>
            <p *ngIf="regra.tipo === 'compre-pizza-ganhe-outra'">Comprando <b>{{regra.quantidade || 0}}</b> pizza(s)
              <b>{{regra.tamanhoPizzaComprar ? regra.tamanhoPizzaComprar.descricao : 'do tamanho escolhido'}}</b>, o cliente ganha
              uma pizza <b>{{regra.tamanhoPizzaGanhar ? regra.tamanhoPizzaGanhar.descricao : 'do outro tamanho'}}</b>.
            </p>
          </div>
        </section>
      </ng-container>
    </div>

    <footer class="pm-rodape">
      <span></span>
      <div class="pm-rodape__botoes">
        <button type="button" class="pm-btn pm-btn--fantasma" (click)="fecharDialogRegra()">Cancelar</button>
        <button type="submit" class="pm-btn pm-btn--primario"><i class="fe-check"></i> {{novaRegra ? 'Adicionar regra' : 'Salvar regra'}}</button>
      </div>
    </footer>
  </form>
</kendo-dialog>
